<template>
  <ul class="collapsible popout">
    <li class="collapsible-margin">
      <div class="collapsible-header">
        <i class="material-icons">casino</i>Resolving Bot Cards
        <i class="material-icons">expand_more</i>
      </div>
      <div class="collapsible-body tech row">
        To resolve a card, flip it face up and consult the nation-specific
        reference tables (see pages 13–22). Use the table with the symbol
        that matches the one shown on bot’s state card. Do not resolve any of
        the text on the card itself.
        <br/><br/> When resolving a card, take the topmost
        action in the table that matches the card drawn. A card matches if the
        name, type, or suit is the same as the action listed in the table. All
        the contents of the row are considered part of the same action. 
        <br/><br/>Any part
        of the action written in bold refers to you. All other text refers to
        the bot. 
        <br/><br/>If no part of the action can be resolved, find the next
        matching action instead. 
        <br/><br/>If some or all of the action can be resolved,
        resolve as much of the action as possible. 
        <br/><br/>Then, unless the action
        specifies otherwise, place the card in the bot’s discard pile. You will
        only ever resolve one action for a card, even if it matches multiple
        actions. If you reveal an unrest card, do not consult the nation-specific
        reference table. Instead, return it to the unrest pile.
      </div>
    </li>
    <li class="collapsible-margin active">
      <div class="collapsible-header">
        <i class="material-icons">casino</i>Resolve Bot Card # {{ currentCard }}
      </div>
      <div class="collapsible-body tech row">
        <div class="col s12">
          <img :src="imageUrl" alt="" class="responsive-img" />
        </div>
        <div
          class="col s12"
          v-if="currentState == 'barbarian' && canTransition"
        >
          <button
            @click="setCurrentState('empire')"
            class="waves-effect waves-light btn col s12 m6 offset-m3"
          >
            <i class="material-icons">refresh</i>Empire
          </button>
        </div>
        <div class="col s12" v-if="currentState == 'empire' && canTransition">
          <button
            @click="setCurrentState('barbarian')"
            class="waves-effect waves-light btn col s12 m6 offset-m3"
          >
            <i class="material-icons">refresh</i>Barbarian
          </button>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { defineComponent, ref, onMounted, watch, reactive } from "vue";
import store from "../store.js";

export default defineComponent({
  props: {
    card: {},
  },
  setup(props) {
    const reactiveNation = reactive(store.bot.nation);
    const currentState = ref(store.bot.nation.state);
    const currentCard = ref(props.card);
    const imageUrl = ref("");
    function setCurrentState(nationState) {
      store.bot.nation.state = nationState;
      currentState.value = nationState;
    }

    watch(reactiveNation, updateImageUrl);
    function updateImageUrl() {
      if (store.bot.nation.state === "empire") {
        imageUrl.value = store.bot.nation.empireActions;
      } else {
        imageUrl.value = store.bot.nation.barbarianActions;
      }
    }

    onMounted(() => {
      var elems = document.querySelectorAll(".collapsible");
      window.M.Collapsible.init(elems, {});
      updateImageUrl();
    });

    return {
      setCurrentState,
      currentState,
      imageUrl,
      canTransition: store.bot.nation.canTransitionState,
      currentCard,
    };
  },
});
</script>

<style></style>
